export const H1Fields = [
    { identifier: 'font-size-h1', type: 'input', field: 'font-size-h1' },
    { identifier: 'font-weight-h1', type: 'input', field: 'font-weight-h1' },
    { identifier: 'font-color-h1', type: 'input', field: 'font-color-h1' }
]
